import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Navigation} from 'swiper/modules';
import {useRef} from "react";
import ArrowLeftIcon from "@/components/icons/ArrowLeftIcon";
import ArrowRightIcon from "@/components/icons/ArrowRightIcon";

export default function Carousel({autoplay, loop, slides, renderSlide, slidesPerView, className, spaceBetween, centerInsufficientSlides, centeredSlidesBounds, centeredSlides, breakpoints, slidesOffsetBefore, slidesOffsetAfter, initialSlide}) {

    const prevBtn = useRef(null);
    const nextBtn = useRef(null);

    return (
        <div className={`ein-logo-carousel ${className}`}>
            <Swiper
                initialSlide={initialSlide || 0}
                modules={[Navigation, Autoplay]}
                // navigation={true}
                spaceBetween={spaceBetween || 32}
                slidesPerView={slidesPerView || 1}
                autoplay={autoplay || false}
                loop={loop || false}
                centerInsufficientSlides={centerInsufficientSlides || false}
                centeredSlides={centeredSlides || false}
                centeredSlidesBounds={centeredSlidesBounds || false}
                slidesOffsetBefore={slidesOffsetBefore || 0}
                slidesOffsetAfter={slidesOffsetAfter || 0}
                breakpoints={breakpoints || {1024: {slidesPerView: 4, spaceBetween: spaceBetween || 32}}}
                navigation={{
                    nextEl: nextBtn.current,
                    prevEl: prevBtn.current,
                }}
            >
                {slides && slides.map((slide, i) => (
                    <SwiperSlide>
                        {renderSlide(slide, i)}
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className={"ein-carousel-navigation select-none"}>
                <div ref={prevBtn} className="swiper-button-prev">
                    <ArrowLeftIcon/>
                </div>
                <div ref={nextBtn} className="swiper-button-next">
                    <ArrowRightIcon/>
                </div>
            </div>
        </div>
    )
}
